import { useEffect, useRef, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Canvas } from '@react-three/fiber';
import { Bloom, EffectComposer, Vignette } from '@react-three/postprocessing';
import Experience from './components/Experience';
import CameraManager from './components/CameraManager';
import HUDOverlay from './components/HUDOverlay';
import Loader from './components/Loader';
import PhonesPage from './pages/PhonesPage';
import WearablesPage from './pages/WearablesPage';
import RouterDataPage from './pages/RouterDataPage';
import FibrePage from './pages/FibrePage';
import BusinessPage from './pages/BusinessPage';
import { TransitionProvider } from './context/TransitionContext';
import Navbar from './components/Navbar';
import './index.css';

function MainExperience() {
  const scrollRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const maxScroll = el.scrollHeight - window.innerHeight;
      setScrollProgress(Math.min(scrollTop / maxScroll, 1));
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Loader />

      {/* Hero background — to activate: set background-image in .hero-bg inside index.css */}
      <div className={`hero-bg${scrollProgress < 0.18 ? ' visible' : ''}`} />

<div className="scroll-wrapper" ref={scrollRef}>
        <div className="canvas-sticky">
          <Canvas
            shadows
            dpr={[1, window.innerWidth > 768 ? 2 : 1.5]}
            camera={{ position: [0, 0, 14], fov: 60 }}
            gl={{ antialias: true, alpha: false }}
          >
            <color attach="background" args={['#1a1a1a']} />

            <Experience />
            <CameraManager scrollProgress={scrollProgress} />

            <EffectComposer>
              <Bloom
                luminanceThreshold={0.2}
                luminanceSmoothing={0.9}
                intensity={1.6}
                mipmapBlur
              />
              <Vignette eskil={false} offset={0.2} darkness={0.7} />
            </EffectComposer>
          </Canvas>
        </div>
      </div>

      <HUDOverlay scrollProgress={scrollProgress} />
    </>
  );
}

export default function App() {
  return (
    <TransitionProvider>
      <Navbar />
      <Routes>
        <Route path="/" element={<MainExperience />} />
        <Route path="/phones" element={<PhonesPage />} />
        <Route path="/wearables" element={<WearablesPage />} />
        <Route path="/data-deals" element={<RouterDataPage />} />
        <Route path="/fibre" element={<FibrePage />} />
        <Route path="/business" element={<BusinessPage />} />
      </Routes>
    </TransitionProvider>
  );
}
